export enum PromoColor {
  PURPLE_TINT = 'purple-tint',
  MINT_TINT = 'mint-tint',
  LIME_TINT = 'lime-tint',
  STONE = 'stone',
  BERRY_TINT = 'berry-tint',
  ORANGE_TINT = 'orange-tint',
  TRANSPARENT = 'transparent'
}
